import React, { Component } from 'react';
import config from 'react-global-configuration';

import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

// Importação do Router
import { Link } from 'react-router-dom';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import RequestApi from '../../Miscelania/RequestApi';
import ModalAlunoMateria from './ModalAlunoMateria';


class TeamTrainingMatterStaffsAcoes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      team_training_matter_staff_id: this.props.team_training_matter_staff_id,
      result: this.props.result,
      approved: this.props.approved,
      modal_props: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.export = this.export.bind(this);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.team_training_matter_staff_id === 'undefined') {
      this.setState({
        result: newProps.result,
        approved: newProps.approved,
        team_training_matter_staff_id: newProps.team_training_matter_staff_id,
      });
    }
  }


  showModal () {
    this.setState({ modal_props: true });
  }

  closeModal () {
    this.setState({ modal_props: false });
  }
  
  export() {
    var team_id = this.props.team_id;
    var staff_id = this.props.staff_id;
    var url = "/exportar/certificado/aluno/" + staff_id + "/" + team_id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }
  render() {
    var self = this;
    if (self.props.approved == 0) {
      return (
        <div>
          <ModalAlunoMateria handleAlert={self.props.handleAlert} closeModal={self.closeModal} team_training_matter_staff_id={self.props.team_training_matter_staff_id} modal={self.state.modal_props} />
          <span className="label label-danger">{self.props.result} - reprovado</span>
          &nbsp;
          <button className="btn btn-info btn-xs" onClick={self.showModal}><i className="fa fa-fw fa-eye"></i></button>
        </div>
      );    
    } else if (self.props.approved == 1) {
      return (
        <div>
          <ModalAlunoMateria handleAlert={self.props.handleAlert} closeModal={self.closeModal}  team_training_matter_staff_id={self.props.team_training_matter_staff_id} modal={self.state.modal_props} />
          <span className="label label-success">{self.props.result} - aprovado</span>&nbsp;
          <button className="btn btn-info btn-xs" onClick={self.showModal}><i className="fa fa-fw fa-eye"></i></button>
        </div>  
      );     
    }
  }
}

export default TeamTrainingMatterStaffsAcoes;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTrainingMatterStaffsAcoes.js